import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false
}) => {
  const {
    isAuthenticated,
    isAdmin
  } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-455" />;
  }
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace data-id="element-456" />;
  }
  return <>{children}</>;
};
export default ProtectedRoute;